import React from 'react';

import Page from 'components/page';
import ScrollTabs from 'components/scrollTabs';
import MarketCharts from 'components/marketCharts';
import AnalyticalReport from 'components/analyticalReport';
import Products from 'components/products';
import FAQ from 'components/faq';
import Feature from 'components/feature';

const tabs = [
  {
    title: 'Data & Research',
    render: AnalyticalReport,
  },
  {
    title: 'Products & Services',
    render: Products,
  },
  {
    title: 'Faqs',
    render: FAQ,
  },
];

const MarketPage = ({ location: { hash } }) => {
  return (
    <Page pageName="market">
      <Feature>
        <MarketCharts />
      </Feature>
      <ScrollTabs tabs={tabs} defaultTab={hash.replace(/#/g, '')} />
    </Page>
  );
};

export default MarketPage;
